import { defineMessages } from 'react-intl-next';

export const i18n: {
	assignee: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterAssigneePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterAssigneeLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterAssigneeLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	assignee: {
		id: 'quick-find.filters.names.assignee',
		defaultMessage: 'Assignee',
		description: 'Label for filtering by assignee',
	},
	jiraFilterAssigneePlaceholder: {
		id: 'quick-find.jira.filter.assignee.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for assignee filter search input',
	},
	jiraFilterAssigneeLabelSelected: {
		id: 'quick-find.jira.filter.assignee.selected',
		defaultMessage: 'Selected',
		description: 'Jira assignee filter selected label',
	},
	jiraFilterAssigneeLabelUnselected: {
		id: 'quick-find.jira.filter.assignee.unselected',
		defaultMessage: 'Suggested',
		description: 'Jira assignee filter unselected label',
	},
});
